var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1722326193529,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4386,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 85.333333H187.733333a102.4 102.4 0 0 0-102.4 102.4v682.666667a68.266667 68.266667 0 0 0 68.266667 68.266667h512a34.133333 34.133333 0 0 0 34.133333-34.133334V187.733333a102.4 102.4 0 0 0-102.4-102.4z m2.56 68.352A34.133333 34.133333 0 0 1 631.466667 187.733333v682.666667H153.6V187.733333a34.133333 34.133333 0 0 1 34.133333-34.133333h409.6l2.56 0.085333z",
    fill: "#cccccc",
    "p-id": 4387
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M870.4 426.666667H665.6a34.133333 34.133333 0 0 0-34.133333 34.133333v443.733333a34.133333 34.133333 0 0 0 34.133333 34.133334h204.8a68.266667 68.266667 0 0 0 68.266667-68.266667V494.933333a68.266667 68.266667 0 0 0-68.266667-68.266666zM699.733333 870.4V494.933333h170.666667v375.466667H699.733333z",
    fill: "#cccccc",
    "p-id": 4388
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.666667 290.133333v136.533334h136.533333v68.266666h-136.533333v136.533334h-68.266667v-136.533334h-136.533333v-68.266666h136.533333v-136.533334h68.266667z",
    fill: "#cccccc",
    "p-id": 4389
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.58dcfc2c.svg";
export { ForwardRef as ReactComponent };